// Main JavaScript file for Hairlong 2.0
// Add interactive functionality as needed

document.addEventListener('DOMContentLoaded', function () {
    // Initialize announcement bar slider
    initAnnouncementSlider();

    // Initialize hero section slider
    initHeroSlider();

    // Initialize methods slider
    initMethodsSlider();

    // Initialize courses slider (Akademie)
    initCoursesSlider();

    // Initialize online courses slider (Akademie)
    initOnlineCoursesSlider();

    // Initialize upcoming dates toggle
    initUpcomingDates();

    // Initialize student results slider
    initStudentResultsSlider();

    // Initialize testimonials slider
    initTestimonialsSlider();

    // Initialize video slider
    initVideoSlider();

    // Initialize before/after sliders
    initBeforeAfterSliders();

    // Initialize FAQ accordion
    initFAQAccordion();

    // Initialize product detail functionality
    initProductDetail();

    // Initialize mobile menu
    initMobileMenu();

    // Language selector functionality (can be expanded)
    const languageSelector = document.querySelector('.header__language');
    if (languageSelector) {
        languageSelector.addEventListener('click', function () {
            // Add language dropdown functionality here
            console.log('Language selector clicked');
        });
    }
});

/**
 * Initialize Mobile Menu
 */
function initMobileMenu() {
    const mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const subToggles = document.querySelectorAll('[data-mobile-sub-toggle]');

    if (!mobileMenu || mobileToggles.length === 0) return;

    mobileToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const isActive = mobileMenu.classList.toggle('is-active');

            // Toggle all hamburger buttons (in case there are multiple)
            document.querySelectorAll('.header__icon-btn--menu').forEach(btn => {
                btn.classList.toggle('is-active', isActive);
            });

            if (isActive) {
                document.body.classList.add('no-scroll');
                document.documentElement.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
                document.documentElement.classList.remove('no-scroll');
            }
        });
    });

    subToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const parent = toggle.closest('.header__mobile-nav-item');
            const subMenu = parent.querySelector('.header__mobile-sub');
            const isActive = toggle.classList.toggle('is-active');

            if (isActive) {
                // Close other submenus
                subToggles.forEach(otherToggle => {
                    if (otherToggle !== toggle) {
                        otherToggle.classList.remove('is-active');
                        const otherParent = otherToggle.closest('.header__mobile-nav-item');
                        const otherSub = otherParent.querySelector('.header__mobile-sub');
                        if (otherSub) otherSub.style.maxHeight = null;
                    }
                });
                subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
            } else {
                subMenu.style.maxHeight = null;
            }
        });
    });
}

/**
 * Toggle upcoming dates extra list
 */
function initUpcomingDates() {
    const containers = document.querySelectorAll('.upcoming:not(.is-initialized)');

    containers.forEach(container => {
        const toggleBtn = container.querySelector('[data-upcoming-toggle]');
        const extra = container.querySelector('[data-upcoming-extra]');
        const label = toggleBtn ? toggleBtn.querySelector('.upcoming__toggle-label') : null;
        const icon = toggleBtn ? toggleBtn.querySelector('.upcoming__toggle-icon') : null;

        if (!toggleBtn || !extra) return;

        container.classList.add('is-initialized');

        // Store original label text
        const originalLabel = label ? label.textContent : 'Mehr Termine';
        const lessLabel = originalLabel.includes('Termine') ? 'Weniger Termine' : 'Show less';

        toggleBtn.addEventListener('click', () => {
            const isOpen = extra.classList.toggle('is-open');
            if (label) {
                label.textContent = isOpen ? lessLabel : originalLabel;
            }
            if (icon) {
                icon.classList.toggle('is-open', isOpen);
            }
        });
    });
}

/**
 * Initialize before/after comparison sliders
 */
function initBeforeAfterSliders() {
    const comparisons = document.querySelectorAll('[data-before-after]');

    comparisons.forEach(function (comparison) {
        const wrapper = comparison.querySelector('.results__image-wrapper');
        const slider = comparison.querySelector('.results__slider');
        const handle = comparison.querySelector('.results__slider-handle');
        const afterImage = comparison.querySelector('.results__image--after');

        if (!wrapper || !slider || !handle || !afterImage) return;

        let isDragging = false;

        function updateSlider(clientX) {
            const rect = wrapper.getBoundingClientRect();
            const x = clientX - rect.left;
            const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));

            slider.style.left = percentage + '%';
            afterImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
        }

        function handleMove(e) {
            if (!isDragging) return;
            e.preventDefault();
            updateSlider(e.clientX || (e.touches && e.touches[0].clientX));
        }

        function handleEnd() {
            isDragging = false;
            handle.style.cursor = 'grab';
        }

        // Mouse events
        slider.addEventListener('mousedown', function (e) {
            e.preventDefault();
            isDragging = true;
            handle.style.cursor = 'grabbing';
            updateSlider(e.clientX);
        });

        handle.addEventListener('mousedown', function (e) {
            e.preventDefault();
            isDragging = true;
            handle.style.cursor = 'grabbing';
            e.stopPropagation();
        });

        wrapper.addEventListener('mousemove', handleMove);
        wrapper.addEventListener('click', function (e) {
            if (!isDragging) {
                updateSlider(e.clientX);
            }
        });

        document.addEventListener('mouseup', handleEnd);

        // Touch events for mobile
        slider.addEventListener('touchstart', function (e) {
            isDragging = true;
            updateSlider(e.touches[0].clientX);
            e.preventDefault();
        });

        handle.addEventListener('touchstart', function (e) {
            isDragging = true;
            e.stopPropagation();
        });

        wrapper.addEventListener('touchmove', function (e) {
            if (isDragging) {
                updateSlider(e.touches[0].clientX);
                e.preventDefault();
            }
        });

        document.addEventListener('touchend', handleEnd);

        // Initialize at 50%
        setTimeout(function () {
            const rect = wrapper.getBoundingClientRect();
            updateSlider(rect.left + rect.width / 2);
        }, 0);
    });
}

/**
 * Initialize FAQ accordion functionality
 */
function initFAQAccordion() {
    const faqItems = document.querySelectorAll('.faq__item');

    faqItems.forEach(function (item) {
        const question = item.querySelector('.faq__question');
        const answer = item.querySelector('.faq__answer');

        if (!question || !answer || question.dataset.faqInitialized) return;
        question.dataset.faqInitialized = 'true';

        question.addEventListener('click', function () {
            const isExpanded = question.getAttribute('aria-expanded') === 'true';

            // Close all other items (optional - can be changed to allow multiple open)
            faqItems.forEach(function (otherItem) {
                if (otherItem !== item) {
                    const otherQuestion = otherItem.querySelector('.faq__question');
                    const otherItemAnswer = otherItem.querySelector('.faq__answer');
                    if (otherQuestion && otherItemAnswer) {
                        otherQuestion.setAttribute('aria-expanded', 'false');
                        otherItem.setAttribute('aria-expanded', 'false');
                    }
                }
            });

            // Toggle current item
            question.setAttribute('aria-expanded', !isExpanded);
            item.setAttribute('aria-expanded', !isExpanded);
        });
    });
}

/**
 * Initialize product detail page functionality
 */
function initProductDetail() {
    // Thumbnail gallery switching
    const thumbnails = document.querySelectorAll('.product-detail__thumbnail');
    const mainImage = document.getElementById('mainProductImage');

    if (thumbnails.length > 0 && mainImage) {
        thumbnails.forEach(function (thumbnail) {
            thumbnail.addEventListener('click', function () {
                // Remove active class from all thumbnails
                thumbnails.forEach(t => t.classList.remove('product-detail__thumbnail--active'));

                // Add active class to clicked thumbnail
                this.classList.add('product-detail__thumbnail--active');

                // Update main image
                const img = this.querySelector('img');
                if (img && !this.classList.contains('product-detail__thumbnail--more')) {
                    mainImage.src = img.src;
                    mainImage.alt = img.alt;
                }
            });
        });
    }

    // Quantity controls
    const quantityInput = document.querySelector('.product-detail__quantity-input');
    const decreaseBtn = document.querySelector('[data-action="decrease"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');

    if (quantityInput && decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener('click', function () {
            const currentValue = parseInt(quantityInput.value) || 1;
            const minValue = parseInt(quantityInput.min) || 1;
            if (currentValue > minValue) {
                quantityInput.value = currentValue - 1;
            }
        });

        increaseBtn.addEventListener('click', function () {
            const currentValue = parseInt(quantityInput.value) || 1;
            const maxValue = parseInt(quantityInput.max) || 99;
            if (currentValue < maxValue) {
                quantityInput.value = currentValue + 1;
            }
        });
    }

    // Color swatch selection
    const colorSwatches = document.querySelectorAll('.product-detail__color-swatch');
    colorSwatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
            colorSwatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
        });
    });

    // Length button selection
    const lengthBtns = document.querySelectorAll('.product-detail__length-btn');
    lengthBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            lengthBtns.forEach(b => b.classList.remove('product-detail__length-btn--active'));
            this.classList.add('product-detail__length-btn--active');
        });
    });
    // Category button selection
    const categoryBtns = document.querySelectorAll('.product-detail__category-btn');
    categoryBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            categoryBtns.forEach(b => b.classList.remove('product-detail__category-btn--active'));
            this.classList.add('product-detail__category-btn--active');
        });
    });

    // Add to cart functionality
    const addToCartBtn = document.querySelector('.product-detail__add-to-cart');
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
            // Add animation or feedback
            const originalText = this.textContent;
            this.textContent = 'IN DEN WARENKORB GELEGT!';
            this.style.background = 'linear-gradient(90deg, #4caf50 0%, #2d7a3e 100%)';

            setTimeout(() => {
                this.textContent = originalText;
                this.style.background = '';
            }, 2000);
        });
    }
}
// Theme Editor Support
document.addEventListener('shopify:section:load', (event) => {
    const sectionType = event.target.getAttribute('data-section-type');

    // Re-initialize scripts based on section type
    if (event.target.querySelector('.upcoming')) {
        initUpcomingDates();
    }
    if (event.target.querySelector('.splide')) {
        // Find specific slider type and re-init
        if (event.target.querySelector('.courses__slider')) initCoursesSlider();
        if (event.target.querySelector('#hero-slider')) initHeroSlider();
        if (event.target.querySelector('#testimonials-slider')) initTestimonialsSlider();
        if (event.target.querySelector('#methods-slider')) initMethodsSlider();
    }
    if (event.target.querySelector('.faq')) {
        initFAQAccordion();
    }
});

// Cart Quantity Controls Handler
document.addEventListener('click', function(e) {
    if (e.target.matches('[data-qty-action]')) {
        const action = e.target.getAttribute('data-qty-action');
        const inputId = e.target.getAttribute('data-qty-input');
        const input = document.getElementById(inputId);
        
        if (!input) return;
        
        let value = parseInt(input.value) || 0;
        
        if (action === 'increase') {
            input.value = value + 1;
        } else if (action === 'decrease' && value > 1) {
            input.value = value - 1;
        } else if (action === 'decrease' && value === 1) {
            input.value = 0;
        }
        
        const form = input.closest('form');
        if (form) form.submit();
    }
});
